export default "__VITE_ASSET__CKSVfKUA__"